import React, { useEffect, useState } from "react";
import Slider from "react-slick";
import {
  RichText,
  Text,
  withSitecoreContext,
  Link,
  LinkFieldValue,
} from "@sitecore-jss/sitecore-jss-react";
import CustomArrow from "../../react-only-components/CarouselArrow";
import CarouselSlide from "./CarouselSlide";
import CarouselDots from "../../react-only-components/CarouselDots";
import { ComponentProps } from "../../types/types";
import { SpecialOffersFields } from "./fields.definitions";
import { SpecialOffersModel, SpecialOffersSlideModel } from "./fields.model";
import LazySection from "../../react-only-components/LazySection";
import "../../styles/@shared/special-offers.scss";
import useMediaQuery from "../../lib/custom-hooks/useMediaQuery";
import { windowService } from "../../utils/window.utils";

interface SpecialOffersProps extends ComponentProps<SpecialOffersFields, {}> {}

const SpecialOffers = (props: SpecialOffersProps) => {
  const isEE = props.sitecoreContext?.pageEditing;
  const model = new SpecialOffersModel(props);
  const isDesktop = useMediaQuery("(min-width: 768px)");
  const [screenWidth, setScreenWidth] = useState(1680);
  const containerPaddingLeft = 32;
  const largeImageWidth = isDesktop ? 664 : 300;
  const smallImageWidth = isDesktop ? 392 : 300;

  const totalElementsWidth =
    model.items.reduce((sumWidths: number, curr: SpecialOffersSlideModel) => {
      if (curr?.type?.value === "offerCardWide") {
        sumWidths += largeImageWidth;
      } else {
        sumWidths += smallImageWidth;
      }

      return sumWidths;
    }, 0) + containerPaddingLeft;
  const shouldInstanceCarousel = totalElementsWidth > screenWidth;

  const settings = {
    infinite: shouldInstanceCarousel,
    dots: shouldInstanceCarousel,
    arrows: !isEE && shouldInstanceCarousel,
    variableWidth: true,
    speed: 500,
    slidesToScroll: 1,
    nextArrow: <CustomArrow direction="next" />,
    prevArrow: <CustomArrow direction="previous" />,
    customPaging: (i) => <CarouselDots />,
  };

  useEffect(() => {
    setScreenWidth(Math.min(windowService()?.innerWidth, 1680));
  }, []);

  useEffect(() => {
    if (typeof window !== 'undefined' && 'customElements' in window) {
      import('@patternfly/pfe-icon-onhighway/dist/pfe-icon.js');
    }
  }, []);

  return (
    <LazySection>
      <div className="special-offers-wrapper" id={props?.rendering?.uid}>
        <div className="special-offers">
          <Text
            tag="p"
            field={model.eyebrow}
            className="hero-banner__eyebrow"
          />
          <Text
            tag="h2"
            field={model.title}
            className=" special-offers__title"
          />
          <RichText
            tag="p"
            field={model.subtitle}
            className="special-offers__subtitle"
          />
          {(isEE || (model.link as any)?.value?.text || (model.link as any)?.value?.href) && (
            <div className={"special-offers__link"}>
              <Link field={model.link as LinkFieldValue} />
              <span className="link-with-arrow link-with-arrow--text">
                <pfe-icon
                  icon="dcx-arrow-forward"
                  size={"24"}
                  color={"complement"}
                />
              </span>
            </div>
          )}

          <Slider {...settings}>
            {model.items.map((item, index) => (
              <div key={index} className="special-offers__slide">
                <CarouselSlide model={item} isEE={isEE} />
              </div>
            ))}
          </Slider>
          <div className="special-offers__footer"></div>
        </div>
      </div>
    </LazySection>
  );
};

export default withSitecoreContext()(SpecialOffers);
